import { get, post } from "../api_helper";

const getFacilities = async () => {
  const url = "get-facilities";
  const response = await get(url);
  return response;
};

const getFacilityById = async (facilityId) => {
  const url = "get-facilitty-by-id?facilityId=" + facilityId;
  const response = await get(url);
  return response;
};

const saveFacility = async (data) => {
  const url = "save-facility";
  const response = await post(url, data);
  return response;
};

const updateFacility = async (data) => {
  const url = "update-facility";
  const response = await post(url, data);
  return response;
};

const createFacilityAccount = async (data) => {
  const url = "create-facility-account";
  const response = await post(url, data);
  return response;
};

const updateFacilityAccount = async (data) => {
  const url = "update-facility-account";
  const response = await post(url, data);
  return response;
};

const deleteFacility = async (facilityId) => {
  const url = "delete-facility?facilityId=" + facilityId;
    const response = await get(url);
    return response;
};

export {
  getFacilities,
  getFacilityById,
  saveFacility,
  updateFacility,
  createFacilityAccount,
  updateFacilityAccount,
  deleteFacility
};
